import React from 'react';
import { connect } from 'react-redux';
import Loans from 'components/Credit24/LoanApplication/LoansAU';
import { loanPaymentsFrequency } from 'consts';
import PropTypes from 'prop-types';

const loanTypes = [...Array(10)].map((currentValue, index, array) => {
  const valueToShow = index + 1;
  return { type: valueToShow, title: valueToShow === array.length ? `${valueToShow}+` : valueToShow };
});

const LoansAUContainer = (props) => (
  <Loans
    loanPaymentsFrequencies={loanPaymentsFrequency}
    loanTypes={loanTypes}
    formState={props.state}
  />
);

LoansAUContainer.propTypes = {
  state: PropTypes.object.isRequired,
};

export default connect((state) => ({ state }))(LoansAUContainer);
